// extracted by mini-css-extract-plugin
module.exports = {"input":"_2i1rYA4pIzfb41MmC9I6Nk"};